module.exports = __webpack_public_path__ + "static/media/COMP.3ba5c9f8.svg";